export default "__VITE_ASSET__Cqn3RNS5__"